import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const legalLinkClassName =
  "text-base md:text-lg font-semibold underline list-disc w-fit";

export const Legal = () => {
  const [t] = useTranslation("global");

  return (
    <>
      <Helmet>Información Legal | Sendola</Helmet>

      <div className="flex flex-col gap-4 w-full min-h-full bg-white px-6 pt-6 pb-40">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold">
          {t("Legal.Title")}
        </h1>
        <h3 className="text-sm md:text-base text-gray-500">
          {t("Legal.Address")}
        </h3>
        <ul className="flex flex-col gap-2 pl-4">
          <a
            href="https://legal.sendola.io/Legal_Policies/terms-of-service-en-202507.pdf"
            className={legalLinkClassName}
          >
            <li>{t("Legal.Bullet1")}</li>
          </a>
          <a
            href="https://legal.sendola.io/Legal_Policies/privacy-policy-en-202507.pdf"
            className={legalLinkClassName}
          >
            <li>{t("Legal.Bullet2")}</li>
          </a>
          <a
            href="https://legal.sendola.io/Legal_Policies/data-retention-policy-en-202507.pdf"
            className={legalLinkClassName}
          >
            <li>{t("Legal.Bullet3")}</li>
          </a>
          <a
            href="https://legal.sendola.io/Legal_Policies/data-security-policy-en-202507.pdf"
            className={legalLinkClassName}
          >
            <li>{t("Legal.Bullet4")}</li>
          </a>
          <a
            href="https://legal.sendola.io/Legal_Policies/disclosure-electronic-communications-en-202507.pdf"
            className={legalLinkClassName}
          >
            <li>{t("Legal.Bullet5")}</li>
          </a>
          <a
            href="https://legal.sendola.io/Legal_Policies/usa-patriot-act-notice-en-202507.pdf"
            className={legalLinkClassName}
          >
            <li>{t("Legal.Bullet6")}</li>
          </a>
        </ul>
      </div>
    </>
  );
};
